/**
 * @graphql cc
 */
import gql from 'graphql-tag';

export const GlobalOperationsUserPermissionTypeQuery =
	// eslint-disable-next-line graphql-relay-compat/no-apollo-fragments -- Read https://go/connie-relay-migration-fyi
	gql`
		query GlobalOperationsUserPermissionTypeQuery {
			user: confluence_atlassianUser(current: true) {
				id
				confluence {
					permissionType
				}
			}
		}
	`;
